module.exports = __webpack_public_path__ + "static/media/p_active.668458ac.png";